export default __webpack_public_path__ + "static/media/logo.6263adc1.svg";